import { i18n } from "services/i18nService";
import { formatDate } from "services/utility/dates";
import {
  formatDateTimeToDateTimeString,
  formatMoney,
} from "services/utility/formatting";

import { OBJECT_TYPES } from "appConstants";

export const columnInfo = [
  {
    name: "auditEventGoTo",
    buttonLabel: i18n("columns.GoTo"),
    buttonAction: "auditEventGoTo",
    isButton: true,
    fixed: true,
    maxWidth: "10rem",
    excludeFromColumnList: true,
  },
  {
    name: "eventDateTime",
    heading: i18n("columns.When"),
    formatFunc: formatDateTimeToDateTimeString,
    defaultSort: true,
    sortDirection: "asc",
    sortable: true,
    default: true,
  },
  {
    name: "userName",
    heading: i18n("columns.Who"),
    minWidth: "10em",
    sortable: true,
    default: true,
  },
  {
    name: "auditAction",
    heading: i18n("columns.Action"),
    sortable: true,
    default: true,
  },
  {
    name: "type",
    heading: i18n("columns.Object"),
    sortable: true,
    default: true,
  },
  {
    name: "objectValue",
    heading: i18n("columns.WhichOne"),
    default: true,
  },
  {
    name: "note",
    heading: i18n("columns.Memo"),
    sortable: true,
  },
  {
    name: "name",
    heading: i18n("columns.Name"),
    sortable: true,
  },
  {
    name: "txnDate",
    heading: i18n("columns.TxnDate"),
    formatFunc: formatDate,
    sortable: true,
  },
  {
    name: "amount",
    heading: i18n("columns.Amount"),
    sortable: true,
    formatFunc: formatMoney,
    align: "right",
  },
];

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: [],
  MONEY_FIELDS: ["amount"],
  DATE_FIELDS: ["txnDate"],
  DATETIME_FIELDS: ["eventDateTime"],
  NON_UTC_DATETIME_FIELDS: [],
  HTML_ENCODED_FIELDS: [],
};

// The structure of the response differs depending on the presence of query parameters:
// If the GET request includes both 'type' and 'id' parameters, it returns a different
// data structure than when those parameters are omitted.
// See https://app.clickup.com/t/868bnjgpx?comment=90110158802753&threadedComment=90110159397986
// TODO: unify with afterGet when https://app.clickup.com/t/868f1g4a8 complete
export const TYPE_FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: [],
  MONEY_FIELDS: [],
  DATE_FIELDS: [],
  DATETIME_FIELDS: ["eventDateTime"],
  NON_UTC_DATETIME_FIELDS: [],
  HTML_ENCODED_FIELDS: [],
};

export const LINE_ACTIONS = [];
export const BATCH_ACTIONS = [];

export const AUDIT_EVENT_TYPES = [
  OBJECT_TYPES.BOM,
  OBJECT_TYPES.CUSTOMER,
  OBJECT_TYPES.ITEM,
  OBJECT_TYPES.JOB,
  OBJECT_TYPES.VENDOR,
  OBJECT_TYPES.ADJUSTMENT,
  OBJECT_TYPES.BUILD,
  OBJECT_TYPES.ESTIMATE,
  OBJECT_TYPES.ITEM_RECEIPT,
  OBJECT_TYPES.INVOICE,
  OBJECT_TYPES.PAYMENT,
  OBJECT_TYPES.PICK_TICKET,
  OBJECT_TYPES.PROCESS,
  OBJECT_TYPES.PURCHASE_ORDER,
  OBJECT_TYPES.RENTAL,
  OBJECT_TYPES.RENTAL_RETURN,
  OBJECT_TYPES.RETURN,
  OBJECT_TYPES.RETURN_TO_VENDOR,
  OBJECT_TYPES.RMA,
  OBJECT_TYPES.SALES_ORDER,
  OBJECT_TYPES.SALES_RECEIPT,
  OBJECT_TYPES.SHIPMENT,
  OBJECT_TYPES.TRANSFER,
  OBJECT_TYPES.WORK_ORDER,
];

export const AUDIT_EVENT_TYPE_OPTIONS = AUDIT_EVENT_TYPES.map(
  ({ typeString, fullString }) => ({
    id: typeString,
    name: i18n(`objectType.${fullString}.Sentence`),
  })
);
